import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { UserService } from '../../shared/services/user.service';
import { BatchService } from 'src/app/shared/services/batch.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { BatchTableComponent } from '../../private/tables/batch-table/batch-table.component';

@Component({
  selector: 'batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.css'],

})
export class BatchComponent implements OnInit {
  httpResponseMessage: any;
  batchForm: FormGroup;
  submitted = false;
  post: any;
  errorMessage: String;
  batchentity: any;
  selected: any;
  maxDate: string;
  minDate: string;
  PK_BatchID: any = '';
  FK_ProgramID: any = '';
  BatchCode: string = '';
  BatchName: string = '';
  buttonTitle: String = 'S A V E ';
  newtitle: String = " N E W ";
  BatchDate: any;
  programs: any;

  @ViewChild(BatchTableComponent) batchtable;
  constructor(
    private FormBuilder: FormBuilder,
    private _batchService: BatchService,
    private _programService: ProgramService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.batchForm = this.FormBuilder.group({
      'PK_BatchID': ['',],
      'FK_ProgramID': ['', Validators.required],
      'BatchCode': ['', Validators.required],
      'BatchDate': ['', Validators.required],
      'BatchName': ['', Validators.required]
    })

    this._programService.refreshNeeded$
      .subscribe(() => {
        this.getAllProgram();
      })
    this.getAllProgram();
  }

  receiveData($event) {
    this.batchentity = $event
    this.BatchName = this.batchentity[0].BatchName;
    this.PK_BatchID = this.batchentity[0].PK_BatchID;
    this.FK_ProgramID = this.batchentity[0].FK_ProgramID;
    this.BatchCode = this.batchentity[0].BatchCode;
    this.BatchDate = this.batchentity[0].BatchDate;
  }

  getAllProgram(): void {
    this._programService.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  postBatch(post): void {
    if (post.PK_BatchID != '' && post.PK_BatchID != null) {
      this.updateBatch(post);
    }
    else {
      this.createBatch(post);
    }
  }

  createBatch(post): void {
    if (this.batchForm.invalid) { return; }
    this.post = JSON.stringify(post);
    this._batchService.postBatch(AppSettings.API_ENDPOINT + AppSettings.CreateBatch, this.post).subscribe(
      data => {
        this.httpResponseMessage = data
        this.openSnackBar(this.httpResponseMessage, '');
        this.batchForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  updateBatch(post) {
    if (this.batchForm.invalid) { return; }
    this.post = JSON.stringify(post);
    this._batchService.updateBatch(AppSettings.API_ENDPOINT + AppSettings.UpdateBatch, this.post).subscribe(
      data => {
        this.httpResponseMessage = data
        this.openSnackBar(this.httpResponseMessage, '');
        this.batchForm.reset();
      },
      error => this.errorMessage = <any>error)
  }
  cleardata() {
    this.batchForm.reset();
  }


  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}

